import { render } from "./ContactUs.vue?vue&type=template&id=3f2dbb93&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=3f2dbb93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2dbb93"]])

export default __exports__